import { Button, CircularProgress, Typography, useTheme } from '@material-ui/core';
import { EmailIconTwoTone, StyledDialog } from '@room-match/shared-ui-components';
import React, { useState } from 'react';
import { useStyles } from './Signup.styles';
import { COLORS } from 'shared/constants/COLORS';
import { GET_FULL_HOST_URL } from 'shared/constants/GET_FULL_HOST_URL';
import { userSendEmail } from 'shared/redux/slicers/user.slicer';
import { useDispatch } from 'react-redux';

interface Props {
  open: boolean;
  close: VoidFunction;
  email: string;
  handleSuccess: VoidFunction;
}

const ResetPasswordModal: React.FC<Props> = ({ open, close, email, handleSuccess }) => {
  const { modalCont, buttonCont, buttonClass } = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const asyncHandleForgotPassword = (): Promise<any> => {
    const redirectTo = `${GET_FULL_HOST_URL}/reset_password`;
    return Promise.resolve(
      dispatch(
        userSendEmail({
          email,
          redirect_to: redirectTo,
        }),
      ),
    );
  };

  const handleReset = async () => {
    setIsLoading(true);
    const response = await asyncHandleForgotPassword();
    if (response) {
      handleSuccess();
    } else {
      close();
    }
  };

  return (
    <StyledDialog
      fullScreen={false}
      style={{ zIndex: 9999, margin: '5px 5px' }}
      open={open}
      onClose={close}
      maxWidth={false}
      aria-labelledby="simple-dialog-title"
    >
      <div className={modalCont}>
        <EmailIconTwoTone fontSize="large" />
        <Typography style={{ fontSize: 20, fontWeight: 500, color: COLORS.PRIMARY, margin: 10 }}>{email}</Typography>
        <Typography style={{ textAlign: 'center', margin: 20 }}>
          This email address is already connected to an account. Do you want to claim this account and reset your
          password?
        </Typography>
        <div className={buttonCont}>
          <Button className={buttonClass} variant="outlined" onClick={close}>
            No
          </Button>
          <Button
            disabled={isLoading}
            className={buttonClass}
            variant="contained"
            color="primary"
            onClick={handleReset}
          >
            {isLoading ? <CircularProgress style={{ width: 25, height: 25 }} /> : 'Yes'}
          </Button>
        </div>
      </div>
    </StyledDialog>
  );
};

export default ResetPasswordModal;
